import React from 'react';
import { Text, View } from 'react-native';
import OpenBoxButton from './OpenBoxButton';
import OpenBox from './OpenBox';
import { LocStr } from '../../../utils/Utils';
import RegularText from '../Text/RegularText';

//= ========================================================================

const OpenBoxPanel = ({
  language,
  isBoxOpen,
  text,
  chosenValue,
  valuesMap,
  onPress,
  onValueChanged,
  noPadding,
  rightOffset,
  topOffset,
  marginBottom,
  cleanBackground,
  withSplit,
  openBoxWidth,
  checkImageLeft,
  keysMap,
}) => {
  const myStyles = {
    container: {
      marginBottom,
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'space-between',
      background: !cleanBackground && !noPadding && '#f7fafc',
      padding: !noPadding && 5,
      paddingStart: !noPadding && 20,
      paddingEnd: !noPadding && 20,

    },
  };

  return (
    <View>
      <View style={myStyles.container}>
        {noPadding
          ? <RegularText marginBottom={0}>{text}</RegularText>
          : <Text>{text}</Text>}
        <OpenBoxButton
          text={keysMap ? LocStr(keysMap[chosenValue], language) : LocStr(valuesMap[chosenValue], language)}
          onPress={onPress}
          noPadding={noPadding}
          cleanBackground={cleanBackground}
          isBoxOpen={isBoxOpen}
          withSplit={withSplit}
        />
        {isBoxOpen && (
        <OpenBox
          onPress={onPress}
          language={language}
          chosenValue={chosenValue}
          valuesMap={valuesMap}
          onValueChanged={onValueChanged}
          noPadding={noPadding}
          right={rightOffset}
          top={topOffset}
          openBoxWidth={openBoxWidth}
          checkImageLeft={checkImageLeft}
        />
        )}
      </View>
    </View>
  );
};
export default OpenBoxPanel;
